import { atom } from 'recoil';
import { CUSTOM_LAYOUT_TYPE_VALUE } from '@typings/setting/layoutType';

/**
 * 특정 페이지에서 CharacterPanel의 layout type을 일시적으로 오버라이드하는 atom.
 *
 * - null: 전역 layoutType 그대로 사용
 * - 값 설정: 해당 layoutType 모드로 강제 렌더 (GAMEUI 등)
 *
 * 사용 패턴:
 *   mount:   setCharPanelLayoutOverride(LAYOUT_TYPE.GAMEUI)
 *   unmount: setCharPanelLayoutOverride(null)
 */
export const charPanelLayoutOverrideState = atom<CUSTOM_LAYOUT_TYPE_VALUE | null>({
  key: 'charPanelLayoutOverrideState',
  default: null,
});

/**
 * CharacterPanel을 강제로 숨기는 atom.
 * cummuMode.isActive 여부와 무관하게 패널을 완전히 숨긴다.
 *
 * 사용 패턴:
 *   setCharPanelForcedHidden(true)   // 숨기기
 *   setCharPanelForcedHidden(false)  // 복원
 *   return () => setCharPanelForcedHidden(false); // unmount 정리
 */
export const charPanelForcedHiddenState = atom<boolean>({
  key: 'charPanelForcedHiddenState',
  default: false,
});

/**
 * CharacterPanel 배경 이미지 URL 오버라이드 atom.
 * - null: 전역(cummuMode) 설정 사용
 * - '' : 배경 이미지 사용 안 함
 * - 'https://...' : 해당 URL 강제 사용
 */
export const charPanelBgImageOverrideState = atom<string | null>({
  key: 'charPanelBgImageOverrideState',
  default: null,
});
